import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@americanexpress/dls-react';
import { FormattedMessage } from 'react-intl';
import styles from './styles/TaiwanContactTable.scss';
const TaiwanContactTable = ({
  intl
}) => /*#__PURE__*/React.createElement("table", {
  className: styles.table
}, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
  className: `${styles.cell} ${styles.topAlignedCell}`
}, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
  id: "confirm.contactTable.title1"
}), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
  href: `mailto:${intl.messages['confirm.contactTable.email1']}`,
  className: styles.emailLink
}, intl.messages['confirm.contactTable.email1']))), /*#__PURE__*/React.createElement("td", {
  className: `${styles.cell} ${styles.topAlignedCell}`
}, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedMessage, {
  id: "confirm.contactTable.title2"
}), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
  href: `mailto:${intl.messages['confirm.contactTable.email2']}`,
  className: styles.emailLink
}, intl.messages['confirm.contactTable.email2'])))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
  className: styles.cell
}, "\u6216\u4F86\u51FD:"), /*#__PURE__*/React.createElement("td", {
  className: styles.cell
}, null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
  className: `${styles.cell} ${styles.topAlignedCell}`
}, /*#__PURE__*/React.createElement(FormattedMessage, {
  id: "confirm.contactTable.address1"
})), /*#__PURE__*/React.createElement("td", {
  className: `${styles.cell} ${styles.topAlignedCell}`
}, /*#__PURE__*/React.createElement(FormattedMessage, {
  id: "confirm.contactTable.address2"
})))));
export default TaiwanContactTable;